var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTips)?_c('div',{staticClass:"window-min-width-tips text-center mini-text"},[_c('div',{staticClass:"mt-3"},[_c('a-icon',{attrs:{"type":"arrows-alt"}})],1),_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.$t('common_275')))]),_c('div',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.$t('common_276')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }